import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "align-items-center flex justify-content-between w-full" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = { class: "align-items-center bg-light-gray border-round-sm flex justify-content-center p-2" }
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  cellspacing: "0",
  role: "table",
  class: "w-full p-datatable pl-3"
}
const _hoisted_6 = { class: "w-3" }
const _hoisted_7 = { class: "w-3" }
const _hoisted_8 = { class: "w-3" }
const _hoisted_9 = { class: "w-3" }
const _hoisted_10 = { class: "p-datatable p-component p-datatable-scrollable p-datatable-responsive-scroll mx-3" }
const _hoisted_11 = { class: "p-datatable-wrapper px-3" }
const _hoisted_12 = ["textContent"]

import { onMounted } from 'vue';
import { can, useDateTime } from '@/composables';
import { useStudentReferralStore } from '@/store';
import { PERMISSIONS } from '@/enum';


export default /*@__PURE__*/_defineComponent({
  __name: 'DashboardCaseloadAdditions',
  setup(__props) {

const { referrals_caseload, loading, getReferralCaseload } = useStudentReferralStore();

onMounted(() => init());

const init = async () => {
  if (can([PERMISSIONS.REFERRAL_CASELOAD])) await getReferralCaseload();
};

const onSort = async (event) => {
  const filters = {
    order_by: event.sortField,
    order: event.sortOrder === 1 ? 'asc' : 'desc',
  };
  await getReferralCaseload(filters);
};

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_Card = _resolveComponent("Card")!

  return (_openBlock(), _createBlock(_component_Card, { class: "page-content-full" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_Icon, {
            name: "group",
            class: "material-icons mr-2 text-primary"
          }),
          _cache[0] || (_cache[0] = _createElementVNode("h2", null, "Caseload Additions", -1)),
          _cache[1] || (_cache[1] = _createElementVNode("small", { class: "flex line-height-4" }, "These students have been added to your caseload in the past 14 days", -1))
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-dark text-xs mr-1" }, "Total", -1)),
          (!_unref(loading))
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "text-sm text-primary-dark font-bold",
                textContent: _toDisplayString(_unref(referrals_caseload).total)
              }, null, 8, _hoisted_4))
            : (_openBlock(), _createBlock(_component_Skeleton, {
                key: 1,
                shape: "rectangle",
                size: "10px"
              }))
        ])
      ])
    ]),
    content: _withCtx(() => [
      (_unref(loading))
        ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
            _cache[3] || (_cache[3] = _createElementVNode("thead", {
              class: "p-datatable-thead",
              role: "rowgroup"
            }, [
              _createElementVNode("tr", { role: "row" }, [
                _createElementVNode("th", { class: "p-sortable-column justify-content-center mx-0" }, [
                  _createElementVNode("div", { class: "p-column-header-content pl-1" }, [
                    _createElementVNode("span", { class: "p-column-title" }, "Organization"),
                    _createElementVNode("span", { class: "p-sortable-column-icon pi pi-fw pi-sort-alt" })
                  ])
                ]),
                _createElementVNode("th", { class: "p-sortable-column justify-content-center" }, [
                  _createElementVNode("div", { class: "p-column-header-content pl-1" }, [
                    _createElementVNode("span", { class: "p-column-title" }, "Student"),
                    _createElementVNode("span", { class: "p-sortable-column-icon pi pi-fw pi-sort-alt" })
                  ])
                ]),
                _createElementVNode("th", { class: "justify-content-center p-sortable-column" }, [
                  _createElementVNode("div", { class: "p-column-header-content pl-1" }, [
                    _createElementVNode("span", { class: "p-column-title" }, "Referral Type")
                  ])
                ]),
                _createElementVNode("th", { class: "p-sortable-column justify-content-center" }, [
                  _createElementVNode("div", { class: "p-column-header-content pl-1" }, [
                    _createElementVNode("span", { class: "p-column-title" }, "Date of Referral"),
                    _createElementVNode("span", { class: "p-sortable-column-icon pi pi-fw pi-sort-alt" })
                  ])
                ])
              ])
            ], -1)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(new Array(4), (i) => {
              return (_openBlock(), _createElementBlock("tr", { key: i }, [
                _createElementVNode("td", _hoisted_6, [
                  _createVNode(_component_Skeleton, {
                    class: "my-1",
                    height: "40px"
                  })
                ]),
                _createElementVNode("td", _hoisted_7, [
                  _createVNode(_component_Skeleton, {
                    class: "my-1",
                    height: "40px"
                  })
                ]),
                _createElementVNode("td", _hoisted_8, [
                  _createVNode(_component_Skeleton, {
                    class: "my-1",
                    height: "40px"
                  })
                ]),
                _createElementVNode("td", _hoisted_9, [
                  _createVNode(_component_Skeleton, {
                    class: "my-1",
                    height: "40px"
                  })
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_DataTable, {
            value: _unref(referrals_caseload).data,
            "data-key": "id",
            "loading-icon": "logo-spinner",
            loading: _unref(loading),
            "responsive-layout": "scroll",
            scrollable: "",
            "scroll-height": "350px",
            onSort: onSort
          }, {
            empty: _withCtx(() => [...(_cache[4] || (_cache[4] = [
              _createTextVNode("No students assigned", -1)
            ]))]),
            default: _withCtx(() => [
              (!_unref(loading))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_Column, {
                      field: "organization",
                      header: "Organization",
                      sortable: ""
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_RouterLink, {
                          to: `/organizations/${slotProps.data.organization_id}`,
                          class: "font-bold",
                          textContent: _toDisplayString(slotProps.data.organization_name)
                        }, null, 8, ["to", "textContent"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "student",
                      header: "Student",
                      sortable: ""
                    }, {
                      body: _withCtx((slotProps) => [
                        _createVNode(_component_RouterLink, {
                          to: `/user/${slotProps.data.student_id}`,
                          class: "font-bold",
                          textContent: _toDisplayString(slotProps.data.student_name)
                        }, null, 8, ["to", "textContent"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_Column, {
                      field: "referral_type_title",
                      header: "Referral Type"
                    }),
                    _createVNode(_component_Column, {
                      field: "referred_at",
                      header: "Date",
                      sortable: ""
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("span", {
                          textContent: _toDisplayString(_unref(useDateTime)().formatIntlDate(data.referred_at))
                        }, null, 8, _hoisted_12)
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["value", "loading"])
        ]),
        _cache[5] || (_cache[5] = _createElementVNode("div", { class: "p-column-resizer-helper hidden" }, null, -1))
      ])
    ]),
    _: 1
  }))
}
}

})